<template>
  <div>
    <el-dialog
      :visible.sync="info.show"
      :modal="false"
      append-to-body
      :close-on-click-modal="false"
      class="thisblack"
      custom-class="center-settings-dialog"
      width="800px"
      >
      <div class="settings-container">
        <!-- 左侧Tab -->
        <div class="nav-side">
          <div
            v-for="item in settingsNav"
            :key="item.key"
            class="nav-item"
            :class="{active: selectedSetting === item.key}"
            @click="selectTab(item)">
            {{item.key=='cloudProxy'?$t('personalInfo.cloudProxy'):$t('coordinationParticipant.audioSetting') }}
          </div>
        </div>

        <!-- 右侧内容 -->
        <div class="content-main">
          <div class="close-btn" @click="done">
            <i class="el-icon-close"></i>
          </div>

          <!-- 云代理设置 -->
          <div v-show="selectedSetting === 'cloudProxy'" class="setting-block">
            <h3>{{$t('personalInfo.cloudProxy')}}</h3>
            <span class="title">{{$t('personalInfo.cloudProxyDetail')}}</span>
            <span class="title">{{$t('personalInfo.cloudProxyPipSide')}}</span>
            <div class="cloudProxyContent">
              <div class="cloudProxyTitle">{{$t('personalInfo.cloudProxy')}}</div>
              <el-switch
                v-if="loadingShow"
                v-model="cloudProxy"
                @change="changeCloudProxy"
                active-color="#03897B"
                inactive-color="#9F9F9F"/>
              <el-button
                v-else
                size="mini"
                round
                :loading="true"
                style="width:40px;height:20px;border-color: #03897B;background-color: #03897B;padding: 4px 15px !important;"/>
            </div>
          </div>

          <!-- 音频三A设置 -->
          <div v-show="selectedSetting === 'audio'" class="setting-block">
            <h3>{{$t('coordinationParticipant.audioSetting')}}</h3>
            <span class="title">{{$t('personalInfo.noise')}}</span>
            <span class="title">{{$t('personalInfo.applyEvent')}}</span>
            <span class="title">{{$t('personalInfo.control')}}</span>
            <span class="title">{{$t('personalInfo.admins')}}</span>
            <div class="setting-content">
              <div class="threeASetting">
                <div class="content" v-for="(label, index) in aecOptions" :key="index">
                  <el-checkbox
                    v-model="tempCheckedOptions[label.key]"
                  >
                    {{ label.text }}
                  </el-checkbox>
                  <span class="contentDetail">{{ label.detail }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="save-button-container" v-show="selectedSetting === 'audio'">
            <el-button
              type="primary"
              @click="saveAudioSettings"
              :disabled="isSettingsUnchanged"
              class="save-button">
              {{ $t('audioSettings.save') }}
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  watch: {
    'info.show': {
      immediate: true,
      async handler (newVal) {
        if (newVal) {
          await this.getCloudProxy()
          await this.getAudioSetting()
        }
      }
    }
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      originalUserData: [],
      checkedOptions: {
        checkedAec: true,
        checkedAns: true,
        checkedAgc: true
      },
      tempCheckedOptions: { // 新增临时存储
        checkedAec: true,
        checkedAns: true,
        checkedAgc: true
      },
      selectedSetting: 'cloudProxy',
      settingsNav: [
        { key: 'cloudProxy', title: 'Cloud Proxy' },
        { key: 'audio', title: 'Audio Setting' }
      ],
      loadingShow: true,
      cloudProxy: false

    }
  },
  computed: {
    ...mapState({
      State: state => state
    }),
    isSettingsUnchanged () {
      return Object.keys(this.checkedOptions).every(
        key => this.checkedOptions[key] === this.tempCheckedOptions[key]
      )
    },
    aecOptions () {
      return [
        { key: 'checkedAec', text: this.$t('coordinationParticipant.openAEC'), detail: this.$t('coordinationParticipant.aecDetail') },
        { key: 'checkedAns', text: this.$t('coordinationParticipant.openANS'), detail: this.$t('coordinationParticipant.ansDetail') },
        { key: 'checkedAgc', text: this.$t('coordinationParticipant.openAGC'), detail: this.$t('coordinationParticipant.agcDetail') }
      ]
    }
  },
  methods: {
    async selectTab (item) {
      if (item.key === 'audio') {
        await this.getAudioSetting()
      } else {
        await this.getCloudProxy()
      }
      this.selectedSetting = item.key
    },
    async getAudioSetting () {
      this.$http.get('/commentator-backend/userSetting/listV2')
        .then(res => {
          if (res.data.errorCode === '0x0') {
            if (res.data.result) {
              this.originalUserData = res.data.result
              const processSettings = (items) => {
                items?.forEach(item => {
                  switch (item.name) {
                    case 'audioAec':
                      this.checkedOptions.checkedAec = item.value === 'true'
                      break
                    case 'audioAns':
                      this.checkedOptions.checkedAns = item.value === 'true'
                      break
                    case 'audioAgc':
                      this.checkedOptions.checkedAgc = item.value === 'true'
                      break
                  }
                })
                // 初始化临时数据
                this.tempCheckedOptions = { ...this.checkedOptions }
              }
              processSettings(res.data?.result)
            }
          }
        }).catch(error => {
          console.error(error)
        })
    },
    // host 更改 = admin更改 = pip更改 三者权限一样
    // 只不过生效最后一次的更改
    // 新增保存方法
    async saveAudioSettings () {
      const modifiedSettings = JSON.parse(JSON.stringify(this.originalUserData))
      const keyMap = {
        checkedAec: 'audioAec',
        checkedAns: 'audioAns',
        checkedAgc: 'audioAgc'
      }

      Object.keys(this.tempCheckedOptions).forEach(key => {
        if (this.tempCheckedOptions[key] !== this.checkedOptions[key]) {
          modifiedSettings.forEach(item => {
            if (item.name === keyMap[key]) {
              item.value = this.tempCheckedOptions[key].toString()
            }
          })
        }
      })

      const params = modifiedSettings
        .filter((newItem, index) => {
          const originalItem = this.originalUserData[index]
          return newItem.value !== originalItem.value
        })
        .map(item => ({
          id: item.id,
          name: item.name,
          type: item.type,
          value: item.value,
          defaultValue: item.defaultValue,
          userId: this.State.loginInfo.id,
          updateTime: Date.now()
        }))

      if (params.length === 0) return

      try {
        const res = await this.$http.post('/commentator-backend/userSetting/saveList', params)
        if (res.data.errorCode === '0x0') {
          this.originalUserData = JSON.parse(JSON.stringify(modifiedSettings))
          this.checkedOptions = { ...this.tempCheckedOptions }
          this.$emit('close')
          this.$message.success(this.$t('personalInfo.saveSuccess'))
        }
      } catch (error) {
        console.error(error)
        this.tempCheckedOptions = { ...this.checkedOptions } // 恢复临时数据
      }
    },
    done () {
      this.$emit('close')
    },
    async getCloudProxy () {
      this.$http.get('/commentator-backend/userSetting/list')
        .then(res => {
          if (res.data.errorCode === '0x0') {
            if (res.data.result) {
              this.cloudProxy = res.data.result.cloudProxy
            }
          }
        }).catch(error => {
          console.error(error)
        })
    },
    changeCloudProxy (value) {
      this.loadingShow = false
      const params = {
        key: 'cloudProxy',
        value: value
      }
      setTimeout(() => {
        this.$http
          .post('/commentator-backend/userSetting/setUserSetting', params)
          .then((res) => {
            if (res.data.errorCode === '0x0') {
              let message = this.$t('personalInfo.onCloud')
              if (!this.cloudProxy) {
                message = this.$t('personalInfo.offCloud')
              }
              this.$message.success(message)
            }
            this.loadingShow = true
          })
      }, 2000)
    }
  }
}
</script>
<style lang="less" scoped>
.thisblack {
  background-color: rgba(0, 0, 0, 0.5);
  overflow-y: hidden;
  display: flex;
}
/deep/.center-settings-dialog {
  border-radius: 6px;
  overflow: hidden;
  margin: auto !important;
  background: none;
  box-shadow: 0px 8px 6px 0px #00000033;
  border: 1px solid  #595959;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
    height: 600px;
  }

  .settings-container {
    display: flex;
    height: 100%;
    // 左侧导航样式
    .nav-side {
      width: 200px;
      background: #141414;
      padding: 20px 0;

      .nav-item {
        color: #9E9E9E;
        padding: 12px 24px;
        cursor: pointer;
        transition: all 0.3s;

        &:hover, &.active {
          color: #FFFFFF;
          background: rgba(255,255,255,0.1);
        }
      }
    }

    // 右侧内容区
    .content-main {
      flex: 1;
      background: rgb(38,38,38);
      position: relative;
      .save-button-container {
        padding: 15px;
        background: #262626;
        border-top: 1px solid #3D3D3D;
        text-align: right;
        position: sticky;
        bottom: 0;
        z-index: 2;

        .save-button {
          background-color: #03897B;
          border-color: #03897B;
          padding: 8px 20px;

          &:hover {
            background-color: #027368;
            border-color: #027368;
          }

          &:active {
            background-color: #015950;
            border-color: #015950;
          }

          &.is-disabled {
            background-color: #6D6D6D;
            border-color: #6D6D6D;
            opacity: 0.6;
          }
        }
      }
      .close-btn {
        position: absolute;
        top: 20px;
        right: 20px;
        color: #fff;
        font-size: 24px;
        cursor: pointer;
        z-index: 1;
      }

      .setting-block {
        height: 100%;
        display: flex;
        padding: 40px;
        flex-direction: column;
        h3 {
          color: #fff;
          margin-bottom: 10px;
          font-size: 18px;
        }
        .title{
          font-size: 14px;
          display: block;
          color:#7B7B7B;
          word-break: keep-all;
        }
        .cloudProxyContent{
          border-radius: 8px;
          padding: 20px;
          display: flex;
          justify-content: space-between;
          .cloudProxyTitle{
            color:#FFFFFF;
          }
        }
        .setting-content {
          border-radius: 8px;
          padding: 20px;
          position: relative;
          .threeASetting{
            .content{
                display: flex;
                align-items: center;
                margin-top: 16px;
                .contentDetail{
                  margin-left: 12px;
                  color: #909090;
                }
                .el-select{
                  width: 70% !important;
                  .el-input__suffix{
                    right: 5px !important;
                  }
                  .el-input{
                    width: 100% !important;
                    background-color: #333339 !important;
                    border-radius: 4px !important;
                    .el-input__inner{
                      opacity: unset !important;
                      padding:0 15px !important;
                    }
                  }
                }
                }
            .el-checkbox {
              color:#fff !important;
              &.is-checked {
                .el-checkbox__label {
                  color: #03897b;
                }
              }
              &.is-disabled {
                .el-checkbox__label {
                  color: #909090;
                }
              }
              .el-checkbox__label {
                padding-left: 5px;
              }
              .el-checkbox__input {
                &.is-checked {
                  .el-checkbox__inner {
                    background: #03897b;
                    border: 2px solid #03897b;
                    &::after {
                      left: 3px;
                    }
                  }
                }
                &.is-disabled {
                  .el-checkbox__inner {
                    background: #909090;
                    border: 2px solid #909090;
                    &::after {
                      left: 3px;
                    }
                  }
                }
                .el-checkbox__inner {
                  background: none;
                  border: 2px solid #666;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
